<template>
    <div id="use-app-wrapper" class="hidden-lg hidden-md" v-show="isBrandedApp">
        <div id="dont-have-app">
            <div class="close pull-left p-t d-inline" @click="close">
                <i class="fa fa-times" aria-hidden="true"></i>
            </div>
            <img class="logo" width="40" :src="logo">
            <div class="text-part">
                <p>
                    <span style="font-size: 16px">{{ companyName }} Free App</span>
                    <br/> Book your service wherever you are!
                </p>
            </div>
            <a :href="url" class="btn btn-default openButton">Open</a>
        </div>
    </div>
</template>

<script>
export default {
    name: "mobileAppPopUp",
    props: {
        companyId: {
            type: Number
        },
        device: {
            type: String
        },
        logo: {
            type: String
        },
        url: {
            type: String
        },
        isBrandedApp: {
            type: String
        },
        companyName: {
            type: String
        }
    },
    methods: {
        close() {
            this.$el.remove();
        }
    }
}
</script>

<style scoped>
#use-app-wrapper {
    z-index: 9999999;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 62px;
    overflow: hidden;
    background: #fff;
    padding: 0px 18px 0px 8px;
    color: #0a0a0a;
}

.close {
    padding-right: 5px;
    padding-top: 20px;
    padding-left: 8px;
    display: inline;
    float: left
}

.openButton {
    display: inline;
    float: right;
    margin-top: 15px;
    margin-right: 0px
}

.text-part {
    display: inline;
    float: left;
    margin-top: 13px;
    font-size: 11px
}

#use-app-wrapper .logo {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    margin-top: 10px;
    display: inline;
    float: left
}

#apps-buttons {
    margin-top: 20px;
    margin-bottom: 20px;
}

.btn-red {
    background: #ec4758 !important;
    border-color: #ec4758 !important;
    color: white !important;
    width: 130px;
}
</style>